import { Container } from 'components/gruenland/atoms/container/Container';
import { FooterLink } from './atoms/Column1';
import FooterBottom from './FooterBottom';
import { FooterLogo } from './FooterLogo';
import { FooterMenu } from './FooterMenu';
import { FooterReviews } from './FooterReviews';

export interface FooterProps {
  headerCol1: string;
  itemsCol1: FooterLink[];
  headerCol2: string;
  itemsCol2: FooterLink[];
  headerLegalMenu: string;
  itemsLegalMenu: FooterLink[];
}

const Footer: React.FC<FooterProps> = ({
  headerCol1,
  itemsCol1,
  headerCol2,
  itemsCol2,
  headerLegalMenu,
  itemsLegalMenu,
}) => {
  return (
    <footer>
      <FooterReviews />
      <div className="bg-primary-green-mid text-white">
        <Container>
          <FooterMenu
            column1={{ header: headerCol1, links: itemsCol1 }}
            column2={{ header: headerCol2, links: itemsCol2 }}
            legalMenu={{ header: headerLegalMenu, links: itemsLegalMenu }}
            className="pb-[60px] pt-12 md:pb-[80px] md:pt-[70px]"
          />
          <FooterLogo className="pb-6 md:pb-[64px]" />
          <FooterBottom legalMenuItems={itemsLegalMenu} className="py-7 md:py-10" />
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
